import React from 'react'
import { MyHeadline } from './Headline.styles'

export interface HeadlineProps {
    props: {
        title: string
        description: string
    }
}

export const Headline: React.FC<HeadlineProps> = ({props}) => {    
    return(
        <MyHeadline.block>
            <MyHeadline.title>{props.title}</MyHeadline.title>
            <MyHeadline.text>{props.description}</MyHeadline.text>
        </MyHeadline.block>
    )
}
